import React from "react";
import {CircularProgress, InputAdornment, TextField} from "@mui/material";
import {useFormContext} from "react-hook-form";
import {useLxTranslations} from "@lxo-blocks/react";
import {TOTP_FORM_TRANSLATION} from "../TotpForm.translation.de";


export const TotpCodeFormInput = React.forwardRef<any, any>((props, ref) => {
    const {t} = useLxTranslations(TOTP_FORM_TRANSLATION);
    const {errors, formState} = useFormContext();
    const {isSubmitting} = formState;


    return (
        <TextField
            {...props}
            ref={ref}
            fullWidth
            placeholder={t("TOTP_INPUT_PLACEHOLDER")}
            label={t("TOTP_INPUT_LABEL")}
            inputProps={{
                "aria-label": "totptoken",
                "maxLength": "7",
                "style": {textAlign: "center", fontWeight: "bold"},
                "position": "relative"
            }}
            InputProps={{
                endAdornment: <>
                    {isSubmitting &&
                        <InputAdornment position="end" style={{position: "absolute", right: "10px"}}>
                            <CircularProgress/>
                        </InputAdornment>
                    }
                </>
            }}
            error={!!errors.totptoken}
            helperText={
                errors.totptoken?.message
            }
            variant="outlined"
            autoComplete="off"
            autoFocus={props.autoFocus}
            disabled={isSubmitting}
            onChange={(event) => {
                event.target.value = formatTotpCode(event.target.value);
                props.onChange(event);
            }}
        />
    );
});

/**
 *
 * @param inputCode the unformatted input totp code
 * @return normalizedCode totp code in pattern 'xxx-xxx'
 */
export function formatTotpCode(inputCode: string): string {
    if (!inputCode) return "";
    let normalizedCode = inputCode.replace(/[^0-9]/gi, "").trim();
    if (normalizedCode.length > 3) {
        return normalizedCode
            .replace(/(\S{3})/g, "$1-")
            .trim()
            .substring(0, 7);
    } else {
        return normalizedCode;
    }
}
